import { render } from "./CommonModalWithPreset.vue?vue&type=template&id=2c04fcec&ts=true&lang=pug"
import script from "./CommonModalWithPreset.vue?vue&type=script&lang=ts"
export * from "./CommonModalWithPreset.vue?vue&type=script&lang=ts"

import "./CommonModalWithPreset.vue?vue&type=style&index=0&id=2c04fcec&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__